var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 450",
    width: 900,
    height: 450,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19L150 28L300 33L450 24L600 19L750 33L900 28L900 0L750 0L600 0L450 0L300 0L150 0L0 0Z",
    fill: "#d4fa69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 78L150 78L300 82L450 69L600 46L750 91L900 91L900 26L750 31L600 17L450 22L300 31L150 26L0 17Z",
    fill: "#c2ef65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 100L150 109L300 114L450 87L600 87L750 118L900 136L900 89L750 89L600 44L450 67L300 80L150 76L0 76Z",
    fill: "#b0e461"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 199L150 253L300 213L450 136L600 204L750 217L900 258L900 134L750 116L600 85L450 85L300 112L150 107L0 98Z",
    fill: "#9fd95e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 258L150 303L300 285L450 240L600 262L750 285L900 294L900 256L750 215L600 202L450 134L300 211L150 251L0 197Z",
    fill: "#8ece5a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 321L150 343L300 316L450 298L600 325L750 316L900 348L900 292L750 283L600 260L450 238L300 283L150 301L0 256Z",
    fill: "#7dc357"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 352L150 366L300 339L450 325L600 348L750 348L900 361L900 346L750 314L600 323L450 296L300 314L150 341L0 319Z",
    fill: "#6db854"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 379L150 384L300 388L450 370L600 388L750 384L900 379L900 359L750 346L600 346L450 323L300 337L150 364L0 350Z",
    fill: "#5dad50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 397L150 415L300 402L450 402L600 406L750 411L900 411L900 377L750 382L600 386L450 368L300 386L150 382L0 377Z",
    fill: "#4da14d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 420L150 433L300 429L450 415L600 424L750 420L900 420L900 409L750 409L600 404L450 400L300 400L150 413L0 395Z",
    fill: "#3e9649"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 451L150 451L300 451L450 451L600 451L750 451L900 451L900 418L750 418L600 422L450 413L300 427L150 431L0 418Z",
    fill: "#2d8b45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg9);
export default __webpack_public_path__ + "static/media/bg9.21f90254b8fa9364c64570b47eb405d6.svg";
export { ForwardRef as ReactComponent };